import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { IApiDataService, ApiDataOptions } from './api-data.interface';
import { catchError, finalize } from 'rxjs/operators';

export class ServerDataSource<T> implements DataSource<T> {
  private dataSubject = new BehaviorSubject<T[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private apiDataService: IApiDataService) {}

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadData(
    id: number,
    page = 1,
    limit = 10,
    options = {},
    sortDirection = 'asc',
    filter = ''
  ) {
    this.loadingSubject.next(true);

    this.apiDataService
      .fetch(id, page, limit, options, sortDirection, filter)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(response => {
        this.dataSubject.next(response);
      });
  }

  getDataObservable() {
    return this.dataSubject.asObservable();
  }
}
